import clsx from 'clsx';
import React from 'react';
import { NumberFormatBase, PatternFormat, NumberFormat, NumericFormat } from 'react-number-format';
import styles from './InputCustom.module.scss';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Autocomplete, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, InputLabel, ListSubheader, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';

const getExpectedDigitsCount = (mask) => {
  if (!mask) {
    return 0;
  }

  const literalDigitsCount = mask.match(/[1-9]/g)?.length ?? 0;
  const placeholderCount = (mask.match(/#/g) || []).length + (mask.match(/0/g) || []).length;

  return literalDigitsCount + placeholderCount;
};

const InputCustom = ({ noLimit, helperText, isTime, format, rules = {}, onChange, form, name, label, placeholder, required = true, isTextarea, isNumber, isRadio, isSelect, options, isDate, disabled, isCheckbox, errorCustom = null, ...otherProps }) => {
  const error = errorCustom !== null ? errorCustom : form?.formState?.errors?.[name];
  const value = form.watch(name);
  if (isNumber) {
    console.log(error);
  }
  return isNumber ? (
    <Controller
      control={form.control}
      name={name}
      rules={{
        required,
        ...(required && { min: 1 }),
        ...(format &&
          !noLimit && {
            validate: (value) => {
              if (!value) {
                return true;
              }

              const cleanValue = value.replace(/\D/g, '');
              return cleanValue.length === getExpectedDigitsCount(format) || 'Введите полный номер';
            },
          }),
      }}
      render={({ field: { onChange, name, value } }) =>
        format ? (
          <PatternFormat
            format={format}
            size="small"
            error={error}
            sx={{ width: '100%', marginBottom: '8px' }}
            helperText={error ? (error?.message ? error?.message : 'Заполните поле') : ''}
            label={label}
            customInput={TextField}
            thousandSeparator={' '}
            name={name}
            value={value}
            placeholder={placeholder}
            onValueChange={(val) => onChange(val.formattedValue)}
          />
        ) : (
          <NumericFormat
            disabled={disabled}
            size="small"
            error={error}
            sx={{ width: '100%', marginBottom: '8px' }}
            helperText={error ? (error?.message ? error?.message : 'Заполните поле') : ''}
            label={label}
            customInput={TextField}
            thousandSeparator={' '}
            name={name}
            value={value}
            placeholder={placeholder}
            onValueChange={(val) => onChange(val.floatValue)}
          />
        )
      }
    />
  ) : isCheckbox ? (
    <FormGroup>
      <FormLabel component="legend">{label}</FormLabel>
      {options?.map((opt) => (
        <FormControlLabel control={<Controller rules={{ required: false }} name={`${name}.${opt?.value}`} control={form.control} render={({ field: props }) => <Checkbox {...props} checked={props.value} onChange={(e) => props.onChange(e.target.checked)} />} />} label={opt?.label} />
      ))}
    </FormGroup>
  ) : isSelect ? (
    <div>
      <FormControl fullWidth size="small" error={!!error} sx={{ mb: '8px' }}>
        <Controller
          name={name}
          control={form.control}
          rules={{ required }}
          render={({ field: { onChange: fieldOnChange, value, ref } }) => (
            <Autocomplete
              disabled={disabled}
              disablePortal
              options={options || []}
              value={options?.find((opt) => opt.value === value) || null}
              size="small"
              onChange={(_, newValue) => {
                const nextValue = newValue?.value || null;
                const transformedValue = onChange ? onChange(nextValue, { form, name, option: newValue }) : nextValue;
                fieldOnChange(transformedValue === undefined ? nextValue : transformedValue);
              }}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              renderInput={(params) => <TextField {...params} label={label} inputRef={ref} error={!!error} helperText={error ? 'Заполните поле' : null} />}
              renderGroup={(params) => (
                <li key={params.key}>
                  <ListSubheader>{params.group}</ListSubheader>
                  {params.children}
                </li>
              )}
              groupBy={(option) => option.group || ''}
            />
          )}
        />
        {/* {error && <FormHelperText>Заполните поле</FormHelperText>} */}
      </FormControl>
      {/* <FormControl fullWidth size="small" error={error} sx={{ mb: '16px' }}>
        <InputLabel id={`select-${name}`}>{label}</InputLabel>
        <Controller
          render={({ field }) => (
            <Select labelId={`select-${name}`} label={label} {...field}>
              {
                options?.map((opt) => [opt?.group && <ListSubheader>{opt?.group}</ListSubheader>, <MenuItem value={opt.value}>{opt.label}</MenuItem>])

                // <MenuItem value={opt.value}>{opt.label}</MenuItem>
              }
            </Select>
          )}
          name={name}
          rules={{ required }}
          control={form.control}
        />
        {error && <FormHelperText>Заполните поле</FormHelperText>}
      </FormControl> */}
    </div>
  ) : isRadio ? (
    value ? (
      <FormControl>
        <Controller
          name={name}
          control={form.control}
          defaultValue={value} // Дефолтное значение здесь
          render={({ field }) => (
            <RadioGroup
              row
              {...field} // Передаём все props (value, onChange) из RHF
            >
              {options?.map((opt) => (
                <FormControlLabel key={opt.value} value={opt.value} control={<Radio />} label={opt.label} />
              ))}
            </RadioGroup>
          )}
        />
      </FormControl>
    ) : (
      <></>
    )
  ) : isDate ? (
    <Controller
      name={name}
      control={form.control}
      rules={{
        required: required ? `${label} обязателен` : false,
      }}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <DatePicker label={label} inputFormat="DD.MM.YYYY" mask="__.__.____" value={value} onChange={onChange} inputRef={ref} renderInput={(params) => <TextField {...params} error={!!error} helperText={error?.message} fullWidth size="small" />} />
      )}
    />
  ) : isTime ? (
    <Controller
      name={name}
      control={form.control}
      rules={{
        required: required ? `${label} обязателен` : false,
      }}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <TimePicker
          ampm={false} // 24-часовой формат
          inputFormat="HH:mm" // Формат отображения
          mask="__:__"
          label={label}
          value={value}
          onChange={onChange}
          inputRef={ref}
          renderInput={(params) => <TextField {...params} error={!!error} helperText={error?.message} fullWidth size="small" />}
        />
      )}
    />
  ) : (
    <Controller
      name={name}
      control={form.control}
      rules={{ required, ...rules }}
      render={({ field }) => (
        <TextField
          InputLabelProps={{
            shrink: true, // Фиксирует label сверху
          }}
          disabled={disabled}
          multiline={isTextarea}
          {...(isTextarea && { rows: 8 })}
          {...otherProps}
          size="small"
          error={error}
          sx={{ width: '100%', marginBottom: '8px' }}
          helperText={helperText ? helperText : error ? 'Заполните поле' : null}
          label={label}
          {...field}
          onChange={(e) => {
            let filteredValue = e.target.value;
            if (onChange) {
              filteredValue = onChange(e.target.value);
            }
            field.onChange(filteredValue);
          }}
        />
      )}
    />
  );
};

export default InputCustom;
